import { render, staticRenderFns } from "./Relative.vue?vue&type=template&id=223c5ec9"
import script from "./Relative.vue?vue&type=script&lang=js"
export * from "./Relative.vue?vue&type=script&lang=js"
import style0 from "./Relative.vue?vue&type=style&index=0&id=223c5ec9&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports